import { CaretDown, CaretUp } from "@phosphor-icons/react";

import SummaryForm from "./SummaryForm";
import { useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import { ShoppingCart } from "@phosphor-icons/react";

const ShowOrderSummary = (props) => {
  const { type, toggleSummary } = props;
  const is_mobile = props.is_mobile || false;
  const { t } = useTranslation();
  const state = useSelector((state) => state);
  const { summary, information } = state.checkoutStore;

  const displayProductCount = () => {
    var productCount = summary.products.reduce(
      (n, item) => (item.qty ? n + item.qty : n),
      0,
    );

    return (
      <div style={{ fontSize: "14px"}} className="ps-1">
        {productCount == 1
          ? t("summary.item")
          : t("summary.items", { items: productCount })}
      </div>
    );
  };

  return (
    <div className="show-order-summary-div col-12 mb-3">
      <div
        className={`border rounded-4 mx-2 mobile-background-color ${information.open_summary ? "" : "pb-0"}`}
      >
        <div
          className={`total separatedContent align-items-center p-3 d-flex`}
          onClick={() =>
            toggleSummary("open_summary", !information.open_summary)
          }
        >
          <div
            className="d-flex align-items-center"
          >
            <ShoppingCart /> {displayProductCount()}
          </div>
          {information.open_summary ? (
            <CaretUp size={24} weight="regular" />
          ) : (
            <CaretDown size={24} weight="regular" />
          )}
        </div>

        <div
          className={`collapsible-summary-div ${
            information.open_summary
              ? "summary-visible"
              : "summary-invisible d-none"
          }`}
        >
          <SummaryForm is_mobile={is_mobile} />
        </div>
      </div>
    </div>
  );
};
export default ShowOrderSummary;
